<template>
	<section class="container-add-user">
		<div class="box-field">
			<b-field label="Email" expanded>
				<div class="input-container">
					<Input
						type="email"
						width="95%"
						height="35px"
						:validation-params="{ format: 'email' }"
						border-focused="#7159c1"
						border-radius="5px"
						@value="email = $event"
						@validation-error="errorEmail = $event"
						@validation-msg="validateEmailMsg = $event"
					/>
					<div v-if="errorEmail" class="error-message animate__animated animate__fadeInDown">
						{{ validateEmailMsg }}
					</div>
				</div>
			</b-field>

			<b-field label="Login" :type="userError ? 'is-danger' : 'is-sucess'" expanded>
				<div class="input-container">
					<Input
						type="email"
						:validation-params="{ format: 'userName' }"
						width="95%"
						height="35px"
						border-focused="#7159c1"
						border-radius="5px"
						@value="login = $event"
						@validation-error="errorUsername = $event"
						@validation-msg="validateMsg = $event"
					/>
					<p v-if="errorUsername" class="error-message animate__animated animate__fadeInDown">
						{{ validateMsg }}
					</p>
				</div>
			</b-field>
		</div>

		<div class="pessoas-container">
			<div class="container-tables">
				<div class="table-box">
					<h1 class="title-pessoas">Pessoas:</h1>
					<div class="search-container">
						<Search width="70%" height="35px" @searchtext="searchtext" />
					</div>
					<b-table
						v-if="data.length > 0"
						:data="data"
						:columns="columns"
						:checked-rows.sync="checkedRows"
						checkable
						paginated
						per-page="5"
						pagination-size="is-small"
					/>
				</div>
				<div class="table-box">
					<h1 class="title-pessoas">Pessoas Selecionadas:</h1>
					<div>
						<div
							v-for="row in checkedRows"
							:key="row.id"
							class="animate__animated animate__fadeInRight box-item-selected"
						>
							<span>
								Razão Social:{{ ' ' + row.nomerazao + '  |  ' }}CPF/CNPJ:{{
									' ' + row.cpfcnpj
								}}</span>
							<span class="bg-circle-close" @click="removeChecked(row)">
								<feather class="circle-close" type="x" size="12" />
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<b-button style="margin-right: 10px" type="is-success" outlined @click="verifyUser(login)">
				Adicionar Usuário
			</b-button>
			<b-button type="is-danger" outlined> Cancelar </b-button>
		</div>
	</section>
</template>

<script>
import Search from '../../layout/components/search';
import * as ecAxios from '../../util/ecAxios';
import Input from '../../layout/components/input/default';
import global from '../../mixins/global';

export default {
	name: 'NewUser',
	components: {
		Search,
		Input,
	},
	mixins: [global],

	data() {
		return {
			status: false,
			login: '',
			validateMsg: '',
			validateEmailMsg: '',
			email: '',
			errorEmail: false,
			errorUsername: false,
			emailError: false,
			// eslint-disable-next-line max-len
			reg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
			checkedRows: [],
			data: [],
			userError: false,
			columns: [
				{
					field: 'id',
					label: 'ID',
					width: '40',
					numeric: true,
				},
				{
					field: 'nomerazao',
					label: 'Razão Social',
				},
				{
					field: 'cpfcnpj',
					label: 'CPF/CNPJ',
				},
				{
					field: 'status',
					label: 'Status',
					centered: true,
				},
				{
					field: 'tipopessoa',
					label: 'Tipo',
				},
			],
			isSwitchedCustom: true,
		};
	},
	activated() {
		this.checkedRows = [];
		this.data = [];
	},
	methods: {
		removeChecked(item) {
			const uniq = this.checkedRows.findIndex((dataRec) => dataRec.id === item.id);
			if (uniq > -1) {
				this.checkedRows.splice(uniq, 1);
			}
		},
		parseData(data) {
			// Comparar dados para não conseguir selecionar duas
			// Pessoas
			this.checkedRows.map((item) => {
				const uniq = data.findIndex((dataRec) => dataRec.id === item.id);
				if (uniq > -1) {
					data.splice(uniq, 1);
				}
				return false;
			});
			data.map((item) => {
				// eslint-disable-next-line no-param-reassign
				item.cpfcnpj = this.formatCnpjCpf(item.cpfcnpj);

				return false;
			});
			this.data = data;
		},
		async searchtext(searchPessoasInput) {
			if (searchPessoasInput !== '') {
				const nwsearch = searchPessoasInput
					.replace('.', '')
					.replace('.', '')
					.replace('-', '')
					.replace('/', '');
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PESSOAS}`, {
						search: nwsearch,
					})
					.then((response) => {
						if (response.status === 200) {
							this.parseData(response.data.pessoas);
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: `${e}`,
							type: 'is-danger',
						});
					});
			} else {
				this.data = [];
			}
		},
		async verifyUser(username) {
			const pessoasId = [];
			this.checkedRows.map((item) => pessoasId.push(item.id));
			if (!this.errorUsername && !this.errorEmail && username) {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIOS}`, {
						limit: 5,
						offset: 0,
						usuario: username,
					})
					.then((response) => {
						if (response.status === 200 && response.data.error === 0) {
							if (response.data.usuarios.length === 0) {
								this.userError = false;
								this.addNewUser(pessoasId);
							} else if (response.data.usuarios.length === 1) {
								const { usuario } = response.data.usuarios[0];
								if (usuario !== username) {
									this.userError = false;
									this.addNewUser(pessoasId);
								} else {
									this.userError = true;
									this.$buefy.notification.open({
										message: 'Já existe usuário com este nome',
										type: 'is-danger',
									});
								}
							} else {
								const { usuarios } = response.data;
								usuarios.map((item) => {
									if (item.usuario !== username) {
										this.userError = false;
										this.addNewUser(pessoasId);
									} else {
										this.userError = true;
									}
									return null;
								});
							}
						} else {
							this.$buefy.notification.open({
								message: 'Escolha outro nome de usuário, este já está em uso!',
								type: 'is-danger',
							});
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: `${e}`,
							type: 'is-danger',
						});
					});
			} else {
				this.userError = true;
				this.$buefy.notification.open({
					duration: 5000,
					message: 'ops!, você não preencheu as informações corretamente',
					type: 'is-danger',
				});
			}
		},
		async addNewUser(pessoasId) {
			if (pessoasId.length >= 1) {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO}`, {
						email: this.email,
						status: 1,
						usuario: this.login,
						pessoa: pessoasId,
					})
					.then((response) => {
						console.log(response);
						if (response.status === 200) {
							if (window.history.length > 1) {
								this.$router.go(-1);
							} else {
								this.userError = false;
								this.emailError = false;
								this.email = '';
								this.login = '';
								this.data = [];
								this.checkedRows = [];
								this.$router.push('/');
							}
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							duration: 5000,
							message: `${e}`,
							type: 'is-danger',
						});
					});
			} else {
				this.$buefy.notification.open({
					duration: 10000,
					message:
						'Falta só mais um passo, você tem que selecionar pelo menos uma empresa para continuar',
					type: 'is-danger',
				});
			}
		},
	},
};
</script>

<style scoped>
.title-pessoas {
	margin-bottom: 20px;
}
.bg-circle-close {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgb(240, 87, 87);
	border-radius: 50%;
	padding: 3px;
}
.bg-circle-close:hover {
	background-color: rgb(182, 64, 64);
	cursor: pointer;
}
.circle-close {
	color: #fff;
}
.input-container {
	width: 100%;
}
.field {
	width: 50% !important;
}
.box-field {
	display: flex;
	width: 100%;
}
.container-tables {
	display: flex;
	width: 100%;
	flex-direction: row;
}
.table-box {
	width: 50%;
	padding: 10px;
}
.box-item-selected {
	display: flex;
	align-items: center;
	padding: 10px;
	border-radius: 10px;
	border: 1px solid #cecece;
	margin-bottom: 10px;
}
.container-add-user {
	padding: 10px;
	background-color: #fff;
	margin-bottom: 15px;
}
.error-message {
	font-size: 12px;
	width: 97%;
	font-weight: bold;
	margin-top: 15px;
	border-radius: 5px;
	padding: 10px;
	background-color: rgba(255, 0, 0, 0.301);
	color: rgb(255, 0, 0);
}
.search-container {
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 20px;
}
.container-table {
	display: flex;
	width: 100%;
	padding-top: 20px;
}
.pessoas-container {
	padding-bottom: 10px;
}
</style>

